// src/context/errors/GlobalErrorBanner.jsx
import { useEffect } from 'react';
import { useError } from './ErrorProvider';
import styles from './errors.module.css';
import { X, AlertCircle, AlertTriangle, AlertOctagon } from 'lucide-react';
import { useAppConfig } from '../AppConfigContext';


export default function GlobalErrorBanner() {
  const { errors, clearError } = useError(); // Очередь ошибок из ErrorProvider
  const { baseLanguage } = useAppConfig();

  // Авто-закрытие для ошибок без retry
  useEffect(() => {
    const timers = errors.map((error, index) => {
      if (error && !error.retry && error.severity !== 'high') {
        return setTimeout(() => clearError(index), 5000);
      }
      return null;
    });
    return () => timers.forEach(timer => timer && clearTimeout(timer));
  }, [errors, clearError]);

  if (!errors || errors.length === 0) return null;

  return (
    <div className={styles.errorContainer}>
      {errors.map((error, index) => {
        if (!error) return null;

        // Выбор сообщения на основе языка
        const message = typeof error.message === 'object' 
          ? error.message[baseLanguage] || error.message.ru 
          : error.message;

        // Выбор иконки в зависимости от severity
        const Icon = {
          low: AlertCircle,
          medium: AlertTriangle,
          high: AlertOctagon,
        }[error.severity] || AlertCircle;
		
		return (
          <div
            key={index}
            className={`${styles.errorBanner} ${styles[error.severity]}`}
            style={{ top: `${20 + index * 80}px` }} // Смещение для стека тостов
          >
            <div className={styles.icon}>
              <Icon size={20} />
            </div>
            <div className={styles.content}>
              <p className={styles.message}>{message}</p>
              {error.retry && (
                <button
                  onClick={() => clearError(index)}
                  className={styles.retryButton}
                >
                  {baseLanguage === 'ru' ? 'Попробовать снова' : 'Try Again'}
                </button>
              )}
            </div>
            <button
              onClick={() => clearError(index)}
              className={styles.closeButton}
            >
              <X size={20} />
            </button>
          </div>
        );
      })}
    </div>
  );
}